/**
 * Recurrence API client — typed functions for task recurrence rules.
 */
import { apiClient } from './index';

export interface RecurrenceRule {
  frequency: 'daily' | 'weekly' | 'monthly' | 'yearly';
  interval: number;
}

export async function setRecurrence(taskId: string, rule: RecurrenceRule): Promise<void> {
  await apiClient.put(`/tasks/${taskId}/recurrence`, rule);
}

export async function removeRecurrence(taskId: string): Promise<void> {
  await apiClient.delete(`/tasks/${taskId}/recurrence`);
}
